import React, { useRef } from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import ParticleComponent from "../components/landing";
import CourseCard from "../components/courseCard";
import WhyUs from "../components/whyUs";
import ResponsiveComponent from "../components/aboutUs";

export default function MainPage() {
  return (
    <div>
      <NavBar/>
      <div style={{ position: "relative" , backgroundColor:"white" }}>
        <ParticleComponent/>
        <div style={{ position: "relative", zIndex: 1 }}>
          <ResponsiveComponent/>
          <WhyUs/>
          <Footer/>
        </div>
      </div>
    </div>
  );
}
